module.exports = __webpack_public_path__ + "img/logo-kmi-white.7574fcee.png";